const riskProfileQues = [
    {
        "ques": "How old are you?",
        "answer": [
            {"opt": "Less than 35 yrs", "point": "5"},
            {"opt": "35 to 45 yrs", "point": "4"},
            {"opt": "46 to 55 yrs", "point": "3"},
            {"opt": "56 to 65 yrs", "point": "2"},
            {"opt": "66 to 75 yrs", "point": "1"},
            {"opt": "Older than 75 yrs", "point": "0"}
        ]
    },
    {
        "ques": "When do you expect to making withdrawals?",
        "answer": [
            {"opt": "In at least 20 yrs", "point": "5"},
            {"opt": "11 to 19 yrs", "point": "4"},
            {"opt": "6 to 10 yrs", "point": "3"},
            {"opt": "2 to 5 yrs", "point": "2"},
            {"opt": "1 to 2 yrs", "point": "1"},
            {"opt": "Less than 1 yr", "point": "0"}
        ]
    },
    {
        "ques": "For this investment, I intend to take:",
        "answer": [
            {"opt": "Higher risk", "point": "5"},
            {"opt": "Moderate to higher risk", "point": "4"},
            {"opt": "Moderate risk", "point": "3"},
            {"opt": "Lower to Moderate risk", "point": "2"},
            {"opt": "Lower risk", "point": "1"},
            {"opt": "Minimal risk", "point": "0"}
        ]
    },
    {
        "ques": "Assuming booming market conditions, what would you expect from this investment over time?",
        "answer": [
            {"opt": "To closely follow the market", "point": "5"},
            {"opt": "To slightly trail the stock market", "point": "4"},
            {"opt": "To trail the stock market and make a moderate gains", "point": "3"},
            {"opt": "To have some stability, but make modest gains", "point": "2"},
            {"opt": "To remain relatively stable, but make small gains", "point": "1"},
            {"opt": "Higher degree of stability, forgoing potential gain", "point": "0"}
        ]
    },
    {
        "ques": "Assuming poor market conditions, what would you expect from this investment?",
        "answer": [
            {"opt": "Perform about as poorly as the broader market", "point": "5"},
            {"opt": "Not lose as much as the broader market", "point": "4"},
            {"opt": "Remain relatively stable in declining market conditions", "point": "3"},
            {"opt": "Lose very little", "point": "2"},
            {"opt": "Earn income", "point": "1"}
        ]
    },
    {
        "ques": "Which of these statements would best describe your attitudes about the next three years performance of this investment?",
        "answer": [
            {"opt": "I am fully aware that high loss of principal is a real possibility", "point": "5"},
            {"opt": "I can tolerate some of loss in principal", "point": "4"},
            {"opt": "I can only tolerate a small loss in my principal", "point": "3"},
            {"opt": "I'd have a hard time tolerating losses", "point": "2"},
            {"opt": "I would prefer to keep loss of principal to the minimum", "point": "0"}
        ]
    },
    {
        "ques": "Which of these statements would best describe your attitudes about the next three month's performance of this investment?",
        "answer": [
            {"opt": "I wouldn't worry about market fluctuations in that time frame", "point": "5"},
            {"opt": "If my investment declined greater than 20%, I'd be concerned", "point": "4"},
            {"opt": "If my investment declined greater than 10%, I'd be concerned", "point": "3"},
            {"opt": "I can tolerate small short-term fluctuations in my investment", "point": "2"},
            {"opt": "I'd be worried by any investment declines", "point": "0"}
        ]
    },
    {
        "ques": "Given 5 hypothetical Portfolios, which performance you be most comfortable with:",
        "answer": [
            {"opt": "WORST YEAR: -2.66% BEST YEAR: 3.5%", "point": "0"},
            {"opt": "WORST YEAR: -3.90% BEST YEAR: 5.41%", "point": "1"},
            {"opt": "WORST YEAR: -5.75% BEST YEAR: 10.58%", "point": "2"},
            {"opt": "WORST YEAR: -9.52% BEST YEAR: 17.20%", "point": "3"},
            {"opt": "WORST YEAR: -15.02% BEST YEAR: 20.42%", "point": "4"},
            {"opt": "WORST YEAR: -27.42% BEST YEAR: 29.52%", "point": "5"}
        ]
    }
];

export default riskProfileQues;